module.exports = __webpack_public_path__ + "static/media/bede.c7a28a23.png";